<div fxLayout class="cipo--width--full" [attr.data-testid]="fieldData().testId">
    @if (fieldData().readonly) {
        <cipo-text-view class="cipo--width--full" [config]="fieldData()" [value]="control().value" />
    } @else {
        <cipo-outline-field
            class="cipo--width--full"
            [markChanged]="fieldData().markChanged && valueChanged()"
            [required]="fieldData().required"
            [error]="control().touched && control().invalid">
            <div fxLayout fxLayoutAlign="space-between center" class="cipo--width--full">
                <mat-checkbox data-testid="cipo-checkbox" [formControl]="control()" class="cipo-checkbox" fxFlex>
                    {{ fieldData().label | translate }}
                    @if (fieldData().required) {
                        <span class="cipo-text--warn-900">*</span>
                    }
                </mat-checkbox>
                @if (fieldData().fieldDescription && !fieldData().readonly) {
                    <mat-icon
                        [title]="fieldData().fieldDescription | translate"
                        data-testid="cipo-checkbox-info"
                        class="material-icons-outlined cipo--cursor--help"
                        fxFlex="none">
                        info
                    </mat-icon>
                }
            </div>
        </cipo-outline-field>
    }
</div>
@if (control().touched && control().invalid) {
    <p class="cipo-field-subscript cipo-text--warn-900">
        {{ control().hasError("custom") ? (control().errors.custom | translate) : ("errors.required" | translate) }}
    </p>
} @else if (fieldData().hint && !fieldData().readonly) {
    <p class="cipo--material--hint">{{ fieldData().hint | translate }}</p>
}
